import { createBrowserHistory } from 'history'

export default createBrowserHistory()



// WEBPACK FOOTER //
// ./src/components/history.js